import React from "react";
import { Radio as AntRadio } from "antd";
import "./Group.less";

export const RadioGroup = ({ options, id, t, ...props }) => (
  <AntRadio.Group id={id} className="tailormed-radio" {...props}>
    {options &&
      options.map((option, index) => (
        <div key={index} id={option.id} style={{ display: "inline-block" }}>
          <AntRadio.Button value={option.key}>{option.value(t)}</AntRadio.Button>
        </div>
      ))}
  </AntRadio.Group>
);
